import { EventEmitter } from 'fbemitter';
const emitter = new EventEmitter();

let productJSON = false;
let selectedVariant = false;
let fullMediaArray = [];
let mediaArray = [];
let variant = false;
let selectedID = false;
let selectedModalID = false;

const ProductGalleryStore = {
  setFullMediaArray(json) {
    productJSON = json;
    if (json.media) { 
      fullMediaArray = json.media;
    }
  },

  getFullMediaArray() { return fullMediaArray; },

  showOnlySelectedVariant(workingArray) {
    // remove media that has an alt tag that matches
    // a variant that is not selected:
    if (variant && productJSON.variants) {
      let nonSelected = [];
      let cleanedArray = [];
      productJSON.variants.forEach(opt => {
        if (opt.title !== variant.title) {
          nonSelected.push(opt.title);
        }
      });
      workingArray.forEach(item => {
        let keep = true;
        nonSelected.forEach(notSelected => {
          if (item.alt === notSelected) { keep = false }
        });
        if (keep) { cleanedArray.push(item) }
      });
      return cleanedArray;
    }
    return workingArray;
  },

  findSelectedID() {
    if (variant && variant.featured_media) {
      return variant.featured_media.id;
    }
    return productJSON.selected_or_first_id;
  },

  addNavInfo(allMedia) {
    if (allMedia.length < 2) {
      // just one item, no prev or next buttons.
      return allMedia;
    }
    let modifiedArray = [];
    let count = 1;
    allMedia.forEach(item => {
      item.nav = {
        'count': count,
        'total': allMedia.length
      };

      // next
      if (allMedia[count]) {
        item.nav.next = allMedia[count].id;
      } else {
        item.nav.next = allMedia[0].id;
      }
      
      // prev
      if (allMedia[count - 2]) {
        item.nav.previous = allMedia[count - 2].id;
      } else {
        item.nav.previous = allMedia[allMedia.length - 1].id;
      }
      modifiedArray.push(item);
      count = count + 1;
    });
    return modifiedArray;
  },

  setMediaArray() {
    if (fullMediaArray.length === 0) { return [] }
    selectedID = this.findSelectedID();
    let workingArray = this.showOnlySelectedVariant(fullMediaArray);
    let first = [];
    let rest = [];
    workingArray.forEach(mediaItem => {
      if (mediaItem.id === selectedID) {
        first.push(mediaItem);
      } else {
        rest.push(mediaItem);
      }
    });
    mediaArray = this.addNavInfo(first.concat(rest));
  },
  getMediaArray() { return mediaArray },

  setSelectedID(id) {
    selectedID = id;
    emitter.emit('selectedID');
  },
  getSelectedID() { return selectedID },
  
  setModalMediaID(id) {
    selectedModalID = id;
    emitter.emit('modalID');
  },
  getModalMediaID() { return selectedModalID },

  setVariant(newVariant) {
    variant = newVariant;
    this.setMediaArray();
    emitter.emit('variant');
  },

  getVariant() { return selectedVariant },

  addListener(eventType: string, fn: Function) {
    return emitter.addListener(eventType, fn);
  },
};

export default ProductGalleryStore;
